import { memo } from 'react';

/**
 * 売価の凡例
 */
const DiscountLegend = () => {
    // 鮮度起因では「10%乖離」は色付けされないが、凡例は全て共通
    // 「連動商品」の場合の凡例は不要
    const items = [
        { className: 'warning', text: '10％乖離' },
        { className: 'deviate-warning', text: '30％乖離' },
        // CMP-1604: 原価割れ判断が不十分なため一時的に削除
        // { className: 'below-cost', text: '原価割れ' },
    ];

    return (
        <div style={{ padding: '0px 20px', display: 'flex', gap: '32px', fontWeight: 'normal', fontSize: '13px' }}>
            {items.map((item, i) => (
                <span key={i} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span className={item.className} style={{ display: 'inline-block', width: '64px', height: '22px' }} />
                    {item.text}
                </span>
            ))}
        </div>
    );
};

export default memo(DiscountLegend);
